import { render } from "./staff-desktop.vue?vue&type=template&id=32d153e7"
import script from "./staff-desktop.vue?vue&type=script&lang=ts"
export * from "./staff-desktop.vue?vue&type=script&lang=ts"
script.render = render

export default script